// Styles
import './normalize.css';
import "./customize.css";
// Components
// Modules
import ReactDOM from 'react-dom';
import App from './App';
import 'pollyfill';

ReactDOM.render(
    <App />,
    document.getElementById('root')
);
// CodCatalogCurso = "100000G12T"
// CodAlumno = "1531316"